import 'datatables.net'
import 'datatables.net-buttons/js/dataTables.buttons.min'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-bs4'
import 'chart.js/dist/Chart.min'
import 'flatpickr'
window.flatpickr = require('flatpickr');

import 'jquery-datetimepicker/build/jquery.datetimepicker.full';
import 'select2/dist/js/select2.full';




// WEBPACK FOOTER //
// ./scripts/autoload/_plugins.js